import type { ReactNode } from 'react';
import { NO_PARTNER, UNLINKED_PARTNER, partnerWord } from './funnel-words';
import './funnel.css';

export interface PartnerSelectProps {
  /** The partner narrowed to (the partner at sign-up): a code, `none`, `unlinked`, or null for every company. */
  value: string | null;
  /** The codes to offer (the period's partners); the chosen one is kept even when absent. */
  partners: readonly string[];
  onChange: (partner: string | null) => void;
}

/**
 * Every partner, no partner, a partner's referrals nobody is linked to, or the companies one partner
 * brought at sign-up: the Funnel and Campaigns boards' filter.
 */
export function PartnerSelect({ value, partners, onChange }: PartnerSelectProps): ReactNode {
  const named = value !== null && value !== NO_PARTNER && value !== UNLINKED_PARTNER;
  const codes = named && !partners.includes(value) ? [...partners, value] : partners;
  return (
    <select
      className="ad-partner-select"
      aria-label="Partner"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
    >
      <option value="">{partnerWord(null)}</option>
      <option value={NO_PARTNER}>{partnerWord(NO_PARTNER)}</option>
      <option value={UNLINKED_PARTNER}>{partnerWord(UNLINKED_PARTNER)}</option>
      {codes.map((code) => (
        <option key={code} value={code}>
          {code}
        </option>
      ))}
    </select>
  );
}
